import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, doc, getDoc } from 'firebase/firestore'

const { db } = initFirebase()

export class FirebaseReportService {
  constructor() {}

  async getAllReports() {
    try {
      const reportsRef = collection(db, 'report')
      const q = query(reportsRef, orderBy('timestamp', 'desc'))
      const querySnapshot = await getDocs(q)
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
    } catch (error) {
      console.error('Error fetching reports:', error)
      throw error
    }
  }

  async getReportById(reportId) {
    try {
      const reportRef = doc(db, 'report', reportId)
      const reportDoc = await getDoc(reportRef)
      if (reportDoc.exists()) {
        return {
          id: reportDoc.id,
          ...reportDoc.data()
        }
      }
      return null
    } catch (error) {
      console.error('Error fetching report:', error)
      throw error
    }
  }
} 